import { Button, Card, Divider, Form, Input } from "antd";
import { LockOutlined, UserOutlined } from "@ant-design/icons";
import i18n from "i18next";
import React from "react";
import "./Login.scss";
import { useNavigate } from "react-router-dom";


function LoginCard(props) {
  const navigate = useNavigate();

  return (
    <Card title={"Passwort setzen"} className="card">
      <Form
        name="forgot_password"
        className="login-form"
        onFinish={props.onFinish}
      >
        <Form.Item
          name="email"
          className="form-item"
          rules={[
            {
              required: true,
              message: "Bitte E-mail eingeben.",
            },
          ]}
        >
          <Input
            prefix={<UserOutlined className="site-form-item-icon" />}
            placeholder={"E-mail"}
          />
        </Form.Item>

        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            className="login-form-button card-first-btn"
          >
            {"Bestätigen"}
          </Button>
        </Form.Item>
      </Form>

      {/*<div className="flex-center">*/}
      {/*  <Button*/}
      {/*    className="lng-btn"*/}
      {/*    style={{ fontWeight: props.language === "en" ? "bold" : "" }}*/}
      {/*    type="link"*/}
      {/*    onClick={() => {*/}
      {/*      i18n.changeLanguage("en");*/}
      {/*      window.localStorage.setItem("language", "en");*/}
      {/*      props.setLanguage("en");*/}
      {/*    }}*/}
      {/*  >*/}
      {/*    {props.translation("english")}*/}
      {/*  </Button>*/}
      {/*</div>*/}
    </Card>
  );
}

export default LoginCard;
